import { string } from 'yup';

export const validateEmail = (email?: string) =>
  string().email('Must be a valid email address').isValidSync(email);
